















import Vue from 'vue';
import { ConfigurationChangeModel, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';
import MStoreMakeChangesLock from '@/components/shared/MStoreMakeChangesLock.vue';

export default Vue.extend({
  name: 'CabinetConfigurationMakeChangesLock',
  data() {
    return {
      lock: null
    };
  },
  methods: {
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Actions.BeginChange,
      StoreConstants.CabinetConfiguration.Actions.EndChange,
      StoreConstants.CabinetConfiguration.Actions.GetChangeWithErrorPage
    ]),
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.SetApplicationDirty]),
    async onChangeReasonEntered(this: any, changeReason: string) {
      const change = {
        description: changeReason
      } as ConfigurationChangeModel;
      try {
        await this.beginChange(change);
        this[StoreConstants.ApplicationDirty.Actions.SetApplicationDirty](false);
      } catch (error) {
        this.$log(error);
      }
    },
    async onReleaseLock(this: any) {
      await this.endChange(this.cabinetConfigurationChange.id);
    }
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChange,
      StoreConstants.CabinetConfiguration.Getters.IsConfigurationLoading,
      StoreConstants.CabinetConfiguration.Getters.BypassConfigurationChangeLock
    ])
  },
  watch: {
    cabinetConfigurationChange(this: any) {
      this.lock = this.cabinetConfigurationChange.lock;
    }
  },
  async mounted(this: any) {
    await this.getChangeWithErrorPage();
    this.lock = this.cabinetConfigurationChange.lock;
  },
  components: {
    MStoreMakeChangesLock
  }
});
